module.exports = __webpack_public_path__ + "img/9788936456818.c4ea7121.jpg";